import { IDictionary } from "@common/models";

const Abort = () => { };

const controller: IDictionary<AbortController> = {};

Abort.set = (key: string) => {
    Abort.controller[key] = new AbortController();
}

Abort.get = (key: string): AbortController => {
    if (Abort.controller[key]) {
        if (Abort.controller[key].signal.aborted)
            Abort.controller[key] = new AbortController();
        return Abort.controller[key];
    } else {
        Abort.controller[key] = new AbortController();
        return Abort.controller[key];
    }
}

Abort.controller = controller;

export default Abort;